
      import API from "!../../../../../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.98.0_@swc+core@1.11.24_@swc+helpers@0.5.15__esbuild@0.25.9_/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.98.0_@swc+core@1.11.24_@swc+helpers@0.5.15__esbuild@0.25.9_/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "../../../../build/webpack/loaders/devtool/devtool-style-inject.js";
      import setAttributes from "!../../../../../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.98.0_@swc+core@1.11.24_@swc+helpers@0.5.15__esbuild@0.25.9_/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.98.0_@swc+core@1.11.24_@swc+helpers@0.5.15__esbuild@0.25.9_/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../../../node_modules/.pnpm/style-loader@4.0.0_webpack@5.98.0_@swc+core@1.11.24_@swc+helpers@0.5.15__esbuild@0.25.9_/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.6.0_@swc+helpers@0.5.15__webpack@5.98.0_@swc+core@1.11.24_@sw_3t67rhipccjkm2dfoeigtkqyke/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!./segment-boundary-trigger.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn;
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.6.0_@swc+helpers@0.5.15__webpack@5.98.0_@swc+core@1.11.24_@sw_3t67rhipccjkm2dfoeigtkqyke/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!./segment-boundary-trigger.css";
       export default content && content.locals ? content.locals : undefined;
